import React from 'react'
import { Badge, Button, Col, Empty, Image, Popover, Row, Space, Tabs } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import { selectListEvent } from 'Store/product/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { LogData, MultiUom, ProductOptions, RequestData } from 'Store/product/types'
import { LoadingView } from 'Components/modal'
import Label from 'Components/text/Label'
import { MyTheme } from 'Components/common/Theme'
import {
  filterUoms,
  formatUnitWaranty,
  getProductStatus,
  getShippingTypes,
  numberWithComma,
  roundNumber,
} from 'helpers/format'
import { appConfig, themeConfig } from 'config'
import LinkText from 'Components/text/LinkText'
import { DefaultStatus, DefaultStatusText, ImageFallback, ProductStatus } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { MultiUploadForm } from 'Components/form'
import { selectDatas } from 'Store/config/selector'

type Props = {
  isShow: boolean
  onClose: () => void
  data?: LogData
  isPackageC?: boolean
} & ReduxProps

const LogHistoryDrawer = (props: Props) => {
  const { isShow, onClose, event, data, isPackageC, configs } = props
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  const priceLabel = configs?.value.price_labels || []

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  console.log('data', data)

  const mappingKey = [
    {
      key: 'title',
      name: 'ชื่อสินค้า',
    },
    {
      key: 'code',
      name: 'รหัสสินค้า',
    },
    {
      key: 'group_name',
      name: 'กลุ่มสินค้า',
    },
    {
      key: 'category_name',
      name: 'หมวดหมู่หลัก',
    },
    {
      key: 'sub_category_name',
      name: 'หมวดหมู่ย่อย',
    },
    {
      key: 'manufacturer_name',
      name: 'ยี่ห้อ',
    },
    {
      key: 'uom_name',
      name: 'หน่วย',
    },
    {
      key: 'details',
      name: 'รายละเอียดสินค้า',
    },
  ]

  const getDataSource = () => {
    const newData = data?.request_current_data as any
    const oldData = data?.request_old_data as any

    const dataSource = [] as {
      key: any
      old_data: any
      new_data: any
      isChange: boolean
    }[]

    mappingKey &&
      mappingKey.forEach(item => {
        const isChanging = ((oldData && oldData[item.key]) || '') !== ((newData && newData[item.key]) || '')
        // if (isChanging) {
        dataSource.push({
          key: item.name,
          old_data: (oldData && oldData[item.key]) || '',
          new_data: (newData && newData[item.key]) || '',
          isChange: isChanging,
        })
        // }
      })

    return dataSource
  }

  const columns = [
    {
      title: 'ชื่อ column',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'ข้อมูลใหม่',
      dataIndex: 'new_data',
      key: 'new_data',
    },
    {
      title: 'ข้อมูลเก่า',
      dataIndex: 'old_data',
      key: 'old_data',
    },
  ]

  const renderCount = (color: string, title: string, count: any, unit: string = 'ซม.') => (
    <DetailText key={title}>
      <Row justify="space-between" align="top" gutter={[8, 8]}>
        <Col>
          {color && <Badge color={color} />}
          {title}
        </Col>
        <Col>
          {count} {unit}
        </Col>
      </Row>
    </DetailText>
  )

  const renderDetail = (weight: number, record: any) => {
    return (
      <>
        {record.weight > 0 && renderCount('grey', 'น้ำหนัก', roundNumber(weight), 'กก.')}
        {record.width > 0 ? renderCount('grey', 'ความกว้าง', roundNumber(record.width)) : ''}
        {record.height > 0 ? renderCount('grey', 'ความสูง', roundNumber(record.height)) : ''}
        {record.depth > 0 ? renderCount('grey', 'ความลึก', roundNumber(record.depth)) : ''}
        {record.length > 0 ? renderCount('grey', 'ความยาว', roundNumber(record.length)) : ''}
        {record.area > 0 ? renderCount('grey', 'พื้นที่', roundNumber(record.area)) : ''}
      </>
    )
  }

  const renderPrice = (weight: number, record: any) => {
    return (
      <>
        {enableProductOnline &&
          renderCount('green', 'ราคาขายออนไลน์', numberWithComma(record?.price || 0, true), 'บาท')}
        {renderCount('orange', 'ราคาขายหน้าร้าน', numberWithComma(record?.offline_price || 0, true), 'บาท')}
        {(record?.price_a || 0) > 0 &&
          renderCount('grey', 'price_a', numberWithComma(record?.price_a || 0, true), 'บาท')}
        {(record?.price_b || 0) > 0 &&
          renderCount('grey', 'price_b', numberWithComma(record?.price_b || 0, true), 'บาท')}
        {(record?.price_c || 0) > 0 &&
          renderCount('grey', 'price_c', numberWithComma(record?.price_c || 0, true), 'บาท')}
      </>
    )
  }

  const renderStock = (weight: number, record: any) => {
    const stockCount = (record.quantity || 0) + (record?.quantity_offline || 0)
    const stock = numberWithComma(stockCount)
    return stock
  }

  const renderImage = (img: string, record: any) => {
    return (
      <Space direction="vertical">
        <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
      </Space>
    )
  }

  const renderStatus = (publish: boolean) => (
    <StatusTag isPass={publish === true} text={publish ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
  )

  const columnsProductOption = [
    {
      title: 'รูปภาพ',
      dataIndex: 'photo',
      key: 'photo',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      render: (price: number) => numberWithComma(price),
    },
    {
      title: 'สต๊อก',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity: number) => numberWithComma(quantity),
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'weight',
      key: 'weight',
      render: renderDetail,
      width: '150px',
    },
    {
      title: 'สถานะ',
      dataIndex: 'publish',
      key: 'publish',
      render: renderStatus,
    },
  ]

  const columnsPackageC = [
    {
      title: 'รูปภาพ',
      dataIndex: 'photo',
      key: 'photo',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      render: renderPrice,
      width: '250px',
    },
    {
      title: 'สต๊อก',
      dataIndex: 'quantity',
      key: 'quantity',
      render: renderStock,
    },
    enableProductOnline
      ? {
          title: '% ขายออนไลน์',
          dataIndex: 'online_percentage',
          key: 'online_percentage',
          render: (val: number) => `${val}%`,
        }
      : {
          title: '',
          dataIndex: 'online_percentage',
          key: 'online_percentage',
          width: '1px',
          render: () => '',
        },
    {
      title: 'รายละเอียด',
      dataIndex: 'weight',
      key: 'weight',
      render: renderDetail,
      width: '150px',
    },
    {
      title: 'สถานะ',
      dataIndex: 'publish',
      key: 'publish',
      render: renderStatus,
    },
  ]

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return (
      <Row justify="space-between" style={{ marginBottom: '6px' }}>
        <Col span={8}>
          <InfoTitle>{title}</InfoTitle>
        </Col>
        <Col span={span} offset={1}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const renderUomDetail = (detail: MultiUom) => {
    return (
      <PopoverContent>
        {renderInfo('Barcode', detail?.barcode)}
        {renderInfo('ราคาขายหน้าร้าน', `${detail?.offline_price} บาท`)}
        {renderInfo('ราคาซื้อ', `${detail?.purchase_price || 0} บาท`)}
        {renderInfo(getConfigName('price_a'), `${detail?.price_a} บาท`)}
        {renderInfo(getConfigName('price_b'), `${detail?.price_b} บาท`)}
        {renderInfo(getConfigName('price_c'), `${detail?.price_c} บาท`)}
        {renderInfo(
          'สถานะสินค้า',
          `${
            detail?.status === DefaultStatus.ACTIVE ? DefaultStatusText.ACTIVE : DefaultStatusText.INACTIVE
          }`,
        )}
      </PopoverContent>
    )
  }

  const renderProductOptionDetail = (detail: ProductOptions) => {
    const uoms = detail?.uoms?.filter(item => !item.is_master)
    const masterUom = detail?.uoms?.find(item => item.is_master)
    return (
      <Row>
        <Col md={24} xs={24}>
          {renderInfo('ชื่อสินค้า', detail?.title)}
          {renderInfo('Barcode', detail?.barcode)}
          {enableProductOnline && renderInfo('น้ำหนัก', `${detail?.weight}  กก.`)}
          {enableProductOnline &&
            renderInfo('เปอร์เซ็นต์ขายบนสต๊อกออนไลน์', `${detail?.online_percentage} %`)}
          {enableProductOnline && renderInfo('ราคาขายออนไลน์', `${detail?.price} บาท`)}
          {renderInfo('ราคาขายหน้าร้าน', `${detail?.offline_price} บาท`)}
          {renderInfo('ราคาซื้อ', `${masterUom?.purchase_price || 0} บาท`)}
          {renderInfo(getConfigName('price_a'), `${detail?.price_a} บาท`)}
          {renderInfo(getConfigName('price_b'), `${detail?.price_b} บาท`)}
          {renderInfo(getConfigName('price_c'), `${detail?.price_c} บาท`)}
          {renderInfo('สถานะ', `${detail?.publish ? DefaultStatusText.ACTIVE : DefaultStatusText.INACTIVE}`)}
        </Col>
        <Col md={24} xs={24}>
          <Title>หน่วยสินค้าอื่น</Title>
          {uoms && uoms.length > 0 ? (
            <div>
              {uoms.map((item, index) => {
                return (
                  <Row key={index} gutter={[8, 8]}>
                    <Col md={8}>{renderInfo('ชื่อหน่วย', item?.uom_name)}</Col>
                    <Col md={8}>{renderInfo('=', `${item?.multiplier} ${masterUom?.uom_name}`)}</Col>
                    <Col>
                      <Popover
                        content={renderUomDetail(item)}
                        title={`${item.uom_name} (${item.multiplier} ${masterUom?.uom_name})`}
                      >
                        <LinkDetail>รายละเอียด</LinkDetail>
                      </Popover>
                    </Col>
                  </Row>
                )
              })}
            </div>
          ) : (
            <Empty />
          )}
        </Col>
      </Row>
    )
  }

  const renderLogDetail = (detail: RequestData) => {
    const waranty =
      detail?.warranty_status === 'off'
        ? 'ไม่มี'
        : 'รับประกัน ' +
          detail?.product_warranty +
          ' ' +
          formatUnitWaranty(detail?.product_warranty_unit || '')
    const refund =
      detail?.refund_status === 'off'
        ? 'ไม่มี'
        : 'ภายใน ' + detail?.product_refund + ' ' + formatUnitWaranty(detail?.product_refund_unit || '')

    const renderProductStatus = (status?: string) => (
      <StatusTag
        isPass={status === ProductStatus.ACTIVE}
        text={getProductStatus(status || ProductStatus.ACTIVE)}
      />
    )

    return (
      <Row>
        <Col md={24} xs={24}>
          <MultiUploadForm
            label="รูปภาพสินค้า"
            token={''}
            onUpdateData={() => {}}
            files={detail?.photos || []}
            listType="picture-card"
            name="photos"
            readOnly={true}
          />
        </Col>
        <Col md={24} xs={24}>
          {renderInfo('ชื่อสินค้า', detail?.title)}
          {renderInfo('รหัสสินค้า', detail?.code)}
          {renderInfo(
            'หมวดหมู่สินค้า',
            `${detail?.group_name}/${detail?.category_name}/${detail?.sub_category_name}`,
          )}
          {renderInfo('รุ่น', detail?.model)}
          {renderInfo('หน่วย', detail?.uom_name)}
          {renderInfo('รายละเอียดสินค้า', detail?.details)}
        </Col>
        <Col md={24} xs={24}>
          {renderInfo('วิธีการใช้งาน', detail?.manual)}
          {renderInfo('การบำรุงรักษา', detail?.maintenant_and_caution)}
          {renderInfo('คุณสมบัติสินค้า', detail?.properties)}
        </Col>
        <Col md={24} xs={24}>
          <Title>ตั้งค่าสินค้า</Title>
          {enableProductOnline && renderInfo('การรับประกัน', waranty)}
          {enableProductOnline && renderInfo('รับคืนสินค้า', refund)}
          {enableProductOnline &&
            renderInfo('ช่องทางการจัดส่ง', getShippingTypes(detail?.shipping_types || []))}
          {enableProductOnline && renderInfo('สถานะสินค้า', renderProductStatus(detail?.status))}
          {renderInfo('สถานะสินค้าบน Terminal', renderProductStatus(detail?.status_pos))}
        </Col>
        <Col md={24} xs={24}>
          <Tabs defaultActiveKey="1" type="line">
            {detail?.product_options?.map((item, index) => {
              return (
                <Tabs.TabPane tab={`ตัวเลือกสินค้าที่ ${index + 1}`} key={index}>
                  <Padding>{renderProductOptionDetail(item)}</Padding>
                </Tabs.TabPane>
              )
            })}
          </Tabs>
        </Col>
      </Row>
    )
  }

  return (
    <DetailDrawer
      title={`รายละเอียดการแก้ไข`}
      width={'60%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={event.IsLoading} />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Tabs defaultActiveKey="1">
            {data?.request_current_data && (
              <Tabs.TabPane tab="ข้อมูลที่แก้ไขใหม่" key="1">
                {renderLogDetail(data.request_current_data)}
              </Tabs.TabPane>
            )}
            {data?.request_old_data && (
              <Tabs.TabPane tab="ข้อมูล Version เก่า" key="2">
                {renderLogDetail(data?.request_old_data)}
              </Tabs.TabPane>
            )}
          </Tabs>
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const LabelStyle: any = styled(Label)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectListEvent(state),
    configs: selectDatas(state),
  }
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 80px;
  height: 80px;
  object-fit: cover;
`
const Link: any = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const DetailText = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-weight: 100;
  line-height: 1;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  padding-right: 10px;
`

const PopoverContent = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  width: 500px;
  max-width: 100%;
`

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const LinkDetail = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  cursor: pointer;
`

const Padding = styled.div`
  padding: 5px 20px;
`

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(LogHistoryDrawer)
